window.qCalendar = {};
// Вспомогательный объект, который управляет общим видом и стилями календаря
window.QCalendarWidget = {
	on: 0,
	dataDate: null, // Дата текущей ячейки
	aboutDay: $('#about-day-mini'),
	sCookiePrefix: '',
	bActive: 0,
	url_prefix: '',
	todayCellClick: function(e)
	{
		qCalendar.fnGotoToday();
		$('.day.cal-cell.today').trigger('click');
	},
	aboutDayClick: function(e)
	{
		var $target = $(e.target);
		if($target.is("span.calendar-mini"))
		{
			var ulDetails = $target.parent().find('.details');
			if( !ulDetails.length )
			{
				var k = $target.closest('li').data('calendarkey'),
				$ulDetails = $('<ul class="details"></ul>');
				var i;
				for(i in qCalendar.oData[QCalendarWidget.dataDate][k])
				{
					if (qCalendar.oData[QCalendarWidget.dataDate][k].hasOwnProperty(i)) // to ommit prototype methods.
					{
						$ulDetails.append('<li>'+qCalendar.oData[QCalendarWidget.dataDate][k][i]+'</li>');
					}
				}
				$target.parent().append($ulDetails);
			}
			else
			{
				if( ulDetails.css('display') == 'block' )
				{
					ulDetails.hide();
				}
				else
				{
					ulDetails.show();
				}
			}
		}
	},
	fnInit: function()
	{
		this.aboutDay.on('click', this.aboutDayClick);
	},
	getHeader: function( aNames, sTdNumber )
	{
		var headers = '',
		count = aNames.length,
		current = 0;
		headers += ( sTdNumber.length ) ? sTdNumber : '<tr>';
		for (var i = 0; i < count; i++)
		{
			current = ( ( i + 1 ) == count ) ? 0 : i + 1;
			headers += '<th class="week-day-caption">' + aNames[current] + '</th>';
		}
		headers += '</tr>';
		return headers;
	},
	// on == 0 || 1 ( Всего 2 состояния )
	// Если добавляется 2 .... N,
	// то необходимо добавить элементы в каждый из массивов
	oData:
	{
		headers: 		[ Date.dayNames, Date.abbrDayNames ],
		headersNubmer:	[ '<tr><th class="week-number">№<sub>н</sub></th>', '' ],
		monthNames: 	[ Date.monthNames, Date.abbrMonthNames ],
		showOnDays: 	[ 'Показать по дням', 'По дням' ],
		todayActivate: 	[
							{
								handler: function(bActive)
								{
								}
							},
							{
								handler: function(bActive)
								{
									if( bActive < 3 )
									{
										$('.day.cal-cell.today').trigger('click');
									}
								}
							}
						],
		dayClick: 		[ // Обработка события при клике на определенный день
							{
								handler: function ( target, objCalendar )
								{
									if(!target.is("td.cal-cell")) target = target.closest("td.cal-cell");
									if(target.is("td.cal-cell"))
									{
										objCalendar.fnOpenCell(target);
									}
								}
							},
							{ // 1
								handler: function ( target, objCalendar )
								{
									if(!target.is("td.cal-cell")) target = target.closest("td.cal-cell");
									if(target.is("td.cal-cell"))
									{
										QCalendarWidget.dataDate = target.data('date');

										var $aboutDayMini = $('#about-day-mini');
										if( target.hasClass('today') )
										{
											$aboutDayMini.addClass('today');
										}
										else
										{
											if( $aboutDayMini.hasClass('today') )
											{
												$aboutDayMini.removeClass('today');
											}
										}
										$aboutDayMini.html(target.html());
										var oContentDateNum = $aboutDayMini.find('.content .date-num');
										$aboutDayMini.find('.content .close').remove();
										oContentDateNum.append('<div class="show-mini-today">Сегодня</div>');
										oContentDateNum.append('<div class="show-mini-close">Закрыть</div>');
										//

										$('.show-mini-today').on( 'click', QCalendarWidget.todayCellClick);

										$('#about-day-mini .calendar-mini').show();

										$('.show-mini-close').click(function()
										{
											$(this).closest('#about-day-mini').hide();
										});
									}
									////////////////////
									//console.log(objCalendar.$table.find('day-changed').removeClass('day-changed'));
									if( objCalendar.$table.find('.day-changed') )
									{
										objCalendar.$table.find('.day-changed').removeClass('day-changed');
									}
									target.addClass('day-changed');
								}
							}
						],
		btnStyle: 		[ // Добавление стилей кнопкам
							{
								handler: function (oButtonsContainer)
								{
								}
							},
							{ // 1
								handler: function (oButtonsContainer)
								{
									oButtonsContainer.height(50);
									oButtonsContainer.find('.btn').addClass('btn-mini');
									oButtonsContainer.parent().css('margin-top', '-26px');
								}
							}
						],
		cellsStyle: 		[ // Добавление стилей ячейкам
							{
								handler: function (oCellsContainer)
								{
								}
							},
							{ // 1
								handler: function (oCellsContainer)
								{
									var $content = oCellsContainer.find('td .content'),
									$contentUl = $content.find('ul'),
									$contentUlLi = $contentUl.find('li');
									$contentUl.css('clear', 'none');
									$contentUlLi.css('clear', 'none');
									oCellsContainer.find('td .content ul li .glyphicon').css('margin-right', '0px');
								}
							}
						],
		weekHeight: 	[ // Определние высоты ячеек
							{
								handler: function (sView, table_new, iCellHeight)
								{
									if(sView=="month") table_new.find("tr td.week-number").css({"height":iCellHeight+"px", "max-height":iCellHeight+"px"});
									if(sView=="year") table_new.find("tr td.cal-cell:first-child").css({"height":iCellHeight+"px", "max-height":iCellHeight+"px"});
								}
							},
							{ // 1
								handler: function (sView, table_new, iCellHeight)
								{
									iCellHeight = 50;// /= Math.ceil(iCellHeight * 0.3);
									if(sView=="month") table_new.find("tr td.week-number").css({"height":iCellHeight+"px", "max-height":iCellHeight+"px"});
									if(sView=="year") table_new.find("tr td.cal-cell:first-child").css({"height":iCellHeight+"px", "max-height":iCellHeight+"px"});
								}
							}
						],
		contentNubmers:	[ // Вставка номера недели
							{
								get: function (itMonth, iMonth, itWeekYear, idtWeekYear)
								{
									var iWeek = (itMonth == iMonth ? itWeekYear : idtWeekYear ) + 1;
									var sWeek = (iWeek<10?"0":"")+iWeek.toString();
									return '<td class="week-number">'+sWeek+'</td>';
								}
							},
							{ // 1
								get: function (itMonth, iMonth, itWeekYear, idtWeekYear)
								{
									return '';
								}
							} ],
		correctString: 	[ // Надписи внутри ячеек
							{ // 0
								get: function (num, str1, str2, str3, var_name)
								{
									return get_correct_str(num, str1, str2, str3, var_name);
								}
							},
							{ // 1
								get: function (num, str1, str2, str3, var_name)
								{
									return '<span class="calendar-mini" style="display: none;">'+get_correct_str(num, str1, str2, str3, var_name)+'</span>';//num;
								}
							}
						],
		viewsButtons: 	[ // Кнопки переключения: "дни/месяцы". По умолчанию скрыты.
							{ // 0
								handler: function (header, sView)
								{
									//header.find("div.viewsButtons").find("button.view-"+sView).button('toggle');
									header.find("div.viewsButtons").show();
									header.find(".btn.todayButton").show();
								}
							},
							{ // 1
								handler: function (header, sView)
								{
									header.find('h3').css('font-size', '14px');
								}
							}
						]
	},
	getData: function( sElementData )
	{
		if( !this.oData[sElementData] ) return console.log("No data: " + sElementData);
		if( !this.oData[sElementData][this.on] )
		{
			console.log("Bad Element: " + this.on);
			this.on = 0;
			console.log("Now Element = " + this.on);
		}

		var data = this.oData[sElementData][this.on];
		switch(sElementData)
		{
			case 'headers':
				return this.getHeader( data, this.oData.headersNubmer[this.on] ); // Используется функция с одинаковым контентом.
				break;
			default:
			break;
		}
		return data;
	}
};

qCalendar.fnInit = function(oOptions)
{
	var oDefaults =
	{
		oCalendars: null // Пока что это обязательный параметр!
		, aCalendarsSelected: false
		, bDebug: false
		, sCookiePrefix: QCalendarWidget.sCookiePrefix
		, aCalendarsTurnedOff: []
	}

	this.oOptions = $.extend({}, oDefaults, oOptions);
	var vOff = 0;
	for( var v in this.oOptions.oCalendars )
	{
		if( this.oOptions.oCalendars[v].checked == "0" )
		{
			this.oOptions.aCalendarsTurnedOff[vOff] = v;
			vOff++;
		}
	}
	this.oLang = $.extend(
	{
		loading: "Идёт загрузка данных. Пожалуйста, подождите."
		, error: "Произошла ошибка. Попробуйте обновить страницу."
		, errorTimeout: "Не был получен ответ от сервера. (Время ожидания запроса истекло)."

	}, this.oOptions.oLang);

	if( (this.oOptions.aCalendarsSelected == "all") || (this.oOptions.aCalendarsSelected === false) )
	{
		//console.dir(this.oOptions.aCalendarsTurnedOff);
		if(this.oOptions.aCalendarsSelected === false) this.fnLoadState();
		//console.dir(this.oOptions.aCalendarsTurnedOff);

		var keyCalendar;
		this.oOptions.aCalendarsSelected = [];
		for(keyCalendar in this.oOptions.oCalendars)
		{
			//console.log($.inArray(keyCalendar, this.oOptions.aCalendarsTurnedOff));
			if($.inArray(keyCalendar, this.oOptions.aCalendarsTurnedOff) == -1)
				this.oOptions.aCalendarsSelected[this.oOptions.aCalendarsSelected.length]=keyCalendar;
		}

	}
	else
	{
		// проверить!!
		var keyCalendar;
		for(keyCalendar in this.oOptions.oCalendars)
			if($.inArray(keyCalendar, this.oOptions.aCalendarsSelected) == -1)
				this.oData.aCalendarsTurnedOff[this.oData.aCalendarsTurnedOff.length] = keyCalendar;
	}
	//console.dir(this.oOptions.aCalendarsSelected);

	this.bDebug = oOptions.bDebug;

	this.$el = $("#calendar");
	this.$header = this.$el.children("div.calendar-header");
	this.$h3 = this.$header.find("h3");
	this.$table = this.$el.children("table");
	this.$refreshButton = this.$header.find("div.refreshButton");

	// Обновляем стили кнопок для маленького календаря
	QCalendarWidget.getData('btnStyle').handler(this.$header);


	this.$calendarsUl = this.$header.find("div.calendarsButton ul");

	this.$dayExtended = null;

	this.xhr = null;
	this.oData;

	this.fnDrawCalendarsList();

	this.sView = "month";
	this.fnGotoToday();

	this.fnSetEvents();
	this.fnSetSize();

	// Инициализация QCalendarWidget
	QCalendarWidget.fnInit();
}


qCalendar.fnSaveState = function()
{
	var oData = {};
	oData.aCalendarsTurnedOff = this.oOptions.aCalendarsTurnedOff;
	localStorage.setItem( 'QCalendar/'+this.oOptions.sCookiePrefix, JSON.stringify(oData) );
}
qCalendar.fnLoadState = function()
{
	var oData = JSON.parse( localStorage.getItem('QCalendar/'+this.oOptions.sCookiePrefix ) );

	if(oData)
	{
		if(oData.aCalendarsTurnedOff)
		{
			var i;
			for(i in oData.aCalendarsTurnedOff)
			{
				$.removeArrayElement(this.oOptions.aCalendarsSelected, oData.aCalendarsTurnedOff[i]);
			}

			this.oOptions.aCalendarsTurnedOff = oData.aCalendarsTurnedOff;

		}
	}

}

qCalendar.fnSetEvents = function()
{

	$(window).on('resize.qcalendar', $.proxy((function()
	{

		var $window = $(window); // # FIXME перенести в другое место, мб сделать глобальной?
		var iHeight_last = $window.height(); // static

		return function()
		{

			var iHeight = $window.height();
			iHeight_last = iHeight;

			setTimeout($.proxy(function()
			{
				if(iHeight = iHeight_last)
				{
					this.fnSetSize();

				}
			}, this), 100);

		}
	})(),this))
	.on('keydown click', $.proxy(function(e)
	{

		if(( (e.type=='keydown') && (e.which == 27) )
		|| ( (e.type=='click') && ( !$(e.target).closest("table.calendar-table").length
			                      || $(e.target).is("a.close") ) ))
		{
			this.fnCloseCell();
			e.stopPropagation();
		}

	},this))

	// Сделаем переключалку видов
	this.$header.find("button.view-month").click($.proxy(function(e){qCalendar.fnGetData({sView:"month"})},this));
	this.$header.find("button.view-year").click($.proxy(function(e){qCalendar.fnGetData({sView:"year"})},this));

	this.$header.find("button.todayButton").click($.proxy(function()
	{
		this.fnGotoToday();

	},this));

	this.$refreshButton.click($.proxy(function()
	{
		//console.log("refresh button pressed");
		this.fnRefresh();

	},this));

	this.$el.on("started.loading requested.loading", $.proxy(function()
	{
		//console.log("started.loading");
		this.$refreshButton.addClass("loading");

		// for testing:
		// this.oButtons.refresh.$btn.toggleClass("loading");

	}, this));

	this.$el.on("completed.loading", $.proxy(function()
	{
		//console.log("completed.loading");
		this.$refreshButton.removeClass("loading");

		// for testing:
		// setTimeout($.proxy(function(){this.oButtons.refresh.$btn.removeClass("loading")},this),2000);

	}, this));

	this.$header.find("div.controlButtons").on('click', 'button', $.proxy(function(e)
	{
		var $target = $(e.currentTarget);
		var iDirection = Number($target.data("direction"));

		switch(this.sView)
		{
			case "month":
				var dt = new Date();
				dt.setDate(1);
				dt.setFullYear(this.iYear);
				dt.setMonth(this.iMonth);

				dt.addMonths(iDirection);
				this.iYear = dt.getFullYear();
				this.iMonth = dt.getMonth();

				break;

			case "year":

				this.iYear = this.iYear+iDirection;
				break;
		}

		this.fnGetData();

	},this));

	this.$header.find("div.calendarsButton ul")
		.on('change', 'input', $.proxy(function(e)
		{
			var bToggle = $(e.target).is(":checked");
			var key = $(e.target).val();
			if(bToggle)
			{
				this.oOptions.aCalendarsSelected[this.oOptions.aCalendarsSelected.length] = key;
				$.removeArrayElement(this.oOptions.aCalendarsTurnedOff, key);
			}
			else
			{
				$.removeArrayElement(this.oOptions.aCalendarsSelected, key);
				this.oOptions.aCalendarsTurnedOff[this.oOptions.aCalendarsTurnedOff.length] = key;
			}

//			console.dir(this.oOptions.aCalendarsSelected);

			this.fnSaveState();

			this.fnGetData();

		}, this))
		.on('click',function(e)
		{
			e.stopImmediatePropagation();
		});

	this.$table.on('click', 'td.cal-cell', $.proxy(function(e)
	{
		var $target = $(e.target);

		if($target.is("a.toggleDetails"))
		{
			var $label = $target.closest("label");
			var $li = $label.closest("li");
			var $content = $li.closest("div.content");
			var $td = $content.closest("td");

			if(! $content.is(".expanded"))
			{
				$content.find("ul.calendars-counts > li > label.active").removeClass("active");
			}

			if(! $label.is(".active"))
			{
				$label.addClass("active");

				var k = $li.data('calendarkey');
				var sDate = $td.data('date');

				//console.log("1");
				if( ! $label.next().is("ul.details"))
				{

					var $ulDetails = $('<ul class="details"></ul>');
					var i;
					for(i in this.oData[sDate][k])
					{
						if (this.oData[sDate][k].hasOwnProperty(i)) // to ommit prototype methods.
						{
							$ulDetails.append('<li>'+this.oData[sDate][k][i]+'</li>');
						}
					}
					$ulDetails.appendTo($li);
				}
			}
			else
			{
				$label.removeClass("active");
			}

			this.fnOpenCell($td);
		}
		else if($target.is("a.openMonth"))
		{
			this.iMonth = $target.closest("td").data("month");
			this.fnGetData({sView:"month"});
		}
		else
		{
			QCalendarWidget.getData('dayClick').handler($target, this);
			/*if(!$target.is("td.cal-cell")) $target = $target.closest("td.cal-cell");
			//console.dir($target);
			if($target.is("td.cal-cell"))
			{
				this.fnOpenCell($target);
			}*/
		}
		//this.fnOpenCell();

		QCalendarWidget.aboutDay.show();

	}, this));


}

qCalendar.fnDrawCalendarsList = function()
{
	var sHtml = ""
	  , sLastGroup = null
	  , keyCalendar
	  , oCalendar
	  , sGroup
	  , sCaption
	  , sIcon
	  , sColor

	for(keyCalendar in this.oOptions.oCalendars)
	{
		oCalendar = this.oOptions.oCalendars[keyCalendar];

		sGroup   = oCalendar.group;
		sCaption = oCalendar.caption;
		sIcon    = oCalendar.icon;
		sColor   = oCalendar.color;

		if(sLastGroup!=sGroup)
		{
			if(sLastGroup !== null) sHtml += '<li class="divider"></li>';
			sHtml += '<li class="group">'+sGroup+'</li>';
			sLastGroup = sGroup;
		}

		sHtml += '<li><label><input name="calendarEnabled[]" type="checkbox" value="'+keyCalendar+'"';
		if($.inArray(keyCalendar,this.oOptions.aCalendarsSelected)!=-1) sHtml += " checked";
		sHtml += '>';

		if(sIcon)
		{
			sHtml += '<i class="glyphicon glyphicon-'+sIcon+'" style="color:'+sColor+'"></i> ';
		}


		sHtml += sCaption+'</label></li>';
	}

	this.$calendarsUl.html(sHtml);
}

qCalendar.fnGotoToday = function()
{
	var today = new Date();
	this.iMonth = today.getMonth();
	this.iYear = today.getFullYear();
	this.iWeek = today.getWeekOfYear();

	this.fnGetData();
}

qCalendar.fnDraw = function()
{

	//console.log("fnDraw!");

	switch(this.sView)
	{
		case "month":
			this.fnDrawMonth();
			break;

		case "year":
			this.fnDrawYear();
			break;
	}

	// Переключим кнопки в соответствии с указанным видом:
	QCalendarWidget.getData('viewsButtons').handler(this.$header, this.sView);
	//this.$header.find("div.viewsButtons").find("button.view-"+this.sView).button('toggle');

	this.fnSetSize();

}

qCalendar.fnDrawYear = function()
{
	this.$h3.html(this.iYear+" год");
	var $table = this.$table.clone(true, true);
	$table.empty();
	var sFirstRow, sSecondRow;
	for(var n = 0; n < 2; n++)
	{
		sFirstRow = "";
		sSecondRow = "";
		for(var i = 0+6*n; i < 6+6*n; i++)
		{
			var sContent = this.fnGetContentHtml_month(i);
			//sContent="Hello!"

			sFirstRow += '<th class="month-caption">' + QCalendarWidget.getData('monthNames')[i] + '</th>';
			sSecondRow +=
			   '<td class="month month-'+i+' cal-cell" data-month="'+i+'">'
			     + '<div class="content">'
			        + '<a class="openMonth">'+ QCalendarWidget.getData('showOnDays') +'</a>'
			        + '<div class="head">\
			               <a class="close">×</a>\
			           </div>\
			           <div class="date-num"></div>'
			         + sContent
			     +'</div>'
			 + '</td>';

		}
		sFirstRow = '<tr>'+sFirstRow+'</tr>';
		sSecondRow = '<tr class="halfyear">'+sSecondRow+'</tr>';
		$table.append(sFirstRow+sSecondRow);
	}

	this.$table.replaceWith($table);
	this.$table = $table;
}

qCalendar.fnDrawMonth = function()
{
	var aDonthNames = QCalendarWidget.getData('monthNames');
	this.$h3.html(aDonthNames[this.iMonth]+"&nbsp;"+this.iYear);

	var $table = this.$table.clone(true, true);
	$table.empty();

	var sTableHeader = QCalendarWidget.getData('headers');

	$table.append(sTableHeader);

	var dt = new Date(this.iYear+"-"+(this.iMonth+1<10?"0":"")+(this.iMonth+1).toString()+"-01");
	//console.log(dt);
	//console.log("dt.getDay()="+dt.getDay());

	var t = new Date(this.iYear+"-"+(this.iMonth+1<10?"0":"")+(this.iMonth+1).toString()+"-01");
	t.setDate(dt.getDate()-1*(dt.getDay()?dt.getDay():7)+1);

	//console.log("(dt.getDay()?dt.getDay():7)=",(dt.getDay()?dt.getDay():7));
	//console.log(t);

	for(var i=0; i<6; i++)
	{
		var $tr = $('<tr class="week"></tr>');
		//console.log("t:", t, " week1:", t.getWeekOfYear(), " day1:", t.getDayOfYear());
		//console.log("dt:",dt, " week2:", dt.getWeekOfYear(), " day2:", dt.getDayOfYear());

		// --------------------------------------------------------------------------------
		//var iWeek = (t.getMonth() == this.iMonth ? t.getWeekOfYear() : dt.getWeekOfYear() ) + 1;  // берем именно dt, чтобы правильно определять 52/53 или 1 недели (52/53 — для декабря, она же 1 для января)
		//var sWeek = (iWeek<10?"0":"")+iWeek.toString();
		//$tr.append('<td class="week-number">'+sWeek+'</td>');
		// --------------------------------------------------------------------------------

		;
		var weekNumberContent = QCalendarWidget.getData('contentNubmers').get( t.getMonth(), this.iMonth, t.getWeekOfYear(), dt.getWeekOfYear());
		if( weekNumberContent.length ) $tr.append(weekNumberContent);
		//break;

		for(var j=0; j<7; j++)
		{
			var iMonth = t.getMonth();
			var aClasses = ["day", "cal-cell"]; // сюда будем записывать css классы
			if(iMonth < this.iMonth) aClasses[aClasses.length] = "prev-month-date";
			else if((iMonth > this.iMonth) || (this.iMonth==11 && iMonth==0)) aClasses[aClasses.length] = "next-month-date";

			if(t.getDay()==6 || t.getDay()==0) aClasses[aClasses.length] = "weekend-date";

			var today = new Date();
			if(t.toDateString() == today.toDateString()) aClasses[aClasses.length] = "today";
			else if(t < today)
			{
				 aClasses[aClasses.length] = "past";
			}

			if (t.getDate() == 1) aClasses[aClasses.length] = "first-day-of-month";

			var sAddClass;
			if(aClasses.length) sAddClass = " class=\""+aClasses.join(" ")+"\"";
			else sAddClass = "";

			var sContent = this.fnGetContentHtml(t);

			$tr.append('\
			    <td'+sAddClass+' data-date="'+t.toMySqlString()+'">\
			        <div class="content">\
			            <div class="head">\
			                <a class="close">×</a>\
			            </div>\
			            <div class="date-num">'
			                + '<span class="month-abbr"> &nbsp;' + Date.abbrMonthNames[iMonth] + ' / </span>'
			                + t.getDate()
			          +'</div>'
			          + sContent
			      +'</div>\
			    </td>'
			);

			t.addDays(1);
		}

		$tr.appendTo($table);

		if((t.getMonth() > this.iMonth) || (this.iMonth==11 && t.getMonth()==0)) break; // iMonth не подойдет. Нам нужно уже после прибавления месяца.

	}

	this.$table.replaceWith($table);
	this.$table = $table;
}

qCalendar.fnOpenCell = function($td)
{
	this.fnCloseCell();
	var sDisplay = $td.children("div.content").find("ul.details-calendar-cover").css('display'),
	bOpen = (sDisplay!==undefined&&sDisplay=='block');
	this.$dayExtended = $td.children("div.content").addClass("expanded");
	var oDetails = this.$dayExtended.find('ul.details');
	if((oDetails===undefined||!oDetails.length)&&bOpen) // Если список уже создан, то нет необходимости его открывать при маленьком количестве ст
	{
		$td.children("div.content.expanded").find("a.toggleDetails").click();
	}
}

qCalendar.fnCloseCell = function()
{
	if(this.$dayExtended !== null)
	{
		this.$dayExtended.removeClass("expanded");
		this.$dayExtended = null;
	}
}

qCalendar.fnGetContentHtml_month = function(iMonth)
{
	var sHtml = ""
	  , oMonth
	  , k
	  , iLen;
	var oMonth = this.oData[iMonth];

	sHtml += "<ul class='calendars-counts'>";
	for(k in oMonth)
	{
		if( k != "titles" )
		{
			//oMonth['titles'][k]
			if( this.oOptions.oCalendars[k] )
			{
				iLen = oMonth[k];
				sHtml += '<li data-calendarkey="'+k+'">';

				if(this.oOptions.oCalendars[k].icon)
				{
					sHtml += '<i class="glyphicon glyphicon-'+this.oOptions.oCalendars[k].icon+'" style="color:'+this.oOptions.oCalendars[k].color+'"></i> ';
				}

				sHtml += '<label>';
				/*sHtml += QCalendarWidget.getData('correctString').get(iLen, this.oOptions.oCalendars[k].titles[0]
				                             , this.oOptions.oCalendars[k].titles[1]
				                             , this.oOptions.oCalendars[k].titles[2]);*/
				sHtml += QCalendarWidget.getData('correctString').get(iLen, oMonth['titles'][k][0]
				                             , oMonth['titles'][k][1]
				                             , oMonth['titles'][k][2]);
				sHtml += '</label>';
				sHtml += "</li>";
			}
		}
	}
	sHtml += "</ul>";

	return sHtml;
}

qCalendar.fnGetContentHtml = function(tDate)
{
	var sHtml = ""
	  , sDt
	  , oDt
	  , k = null
	  , sIcon
	  , iLen
	  , iLenODt = 0
	  , iLenODtElement = 0
	  , bShowNames = false
	  , sShowNames = ''
	  , bGroup = true
	  , iPrefix = 0;

	oDt = this.oData[tDate.toMySqlString()];
	if( !QCalendarWidget.on )
	{
		for(k in oDt)
		{
			if( this.oOptions.oCalendars[k] )
			{
				iLenODtElement += oDt[k].length;
			}
			iLenODt++;
		}
		if( iLenODt < 3 && iLenODtElement < 3 ) bShowNames = true;
		else if(iLenODt == 1 && iLenODtElement > 2) bShowNames = iPrefix = iLenODtElement - 2; // == true
	}

	sHtml += "<ul class='calendars-counts'>";
	for(k in oDt)
	{
		if( bShowNames ) sShowNames = '<ul class="details-calendar-cover" >';
		if( this.oOptions.oCalendars[k] )
		{
			iLen = oDt[k].length;
			sHtml += '<li data-calendarkey="'+k+'">';

			if(this.oOptions.oCalendars[k].icon) // Проверяем иконку
			{
				sIcon = '<i class="glyphicon glyphicon-'+this.oOptions.oCalendars[k].icon+'" style="color:'+this.oOptions.oCalendars[k].color+'"></i> ';
			}


			var aTitles = this.oOptions.oCalendars[k].titles;
			if(!(aTitles[0]+aTitles[1]+aTitles[2]).length)
			{
				sHtml += '<ul>';
				var aLines = [];

				for( var line in oDt[k] )
				{
					aLines.push(sIcon + oDt[k][line]);
				}
				if( aLines.length ) sHtml += '<li>' + aLines.join('</li><li>') + '</li></ul>';
				bGroup = false;
			}
			else
			{
				sHtml += sIcon;
				sHtml += '<label>';
				sHtml += '<a class="toggleDetails">';
				/*sHtml += QCalendarWidget.getData('correctString').get(iLen, this.oOptions.oCalendars[k].titles[0]
				                             , this.oOptions.oCalendars[k].titles[1]
				                             , this.oOptions.oCalendars[k].titles[2]);*/
				sHtml += QCalendarWidget.getData('correctString').get(iLen, oDt['titles'][k][0]
				                             , oDt['titles'][k][1]
				                             , oDt['titles'][k][2]);
				sHtml += '</a>';
				if(bShowNames)
				{
					for( var i in oDt[k] )
					{
						sShowNames += '<li> - ' + oDt[k][i] + '</li>';
						if( iPrefix && parseInt(i) == 1 )
						{
							/*sPrefixName = QCalendarWidget.getData('correctString').get(iPrefix, this.oOptions.oCalendars[k].titles[0]
				                             , this.oOptions.oCalendars[k].titles[1]
				                             , this.oOptions.oCalendars[k].titles[2]);*/
							var sPrefixName = QCalendarWidget.getData('correctString').get(iPrefix, oDt['titles'][k][0]
				                             , oDt['titles'][k][1]
				                             , oDt['titles'][k][2]);
							sShowNames += '<li class="more"><a>+ ещё ' + sPrefixName + '</a></li>';
							break;
						}
					}
				}
				sHtml += '</label>';
				bGroup = true;
			}




			sHtml += "</li>";
			if(bShowNames && bGroup)
			{
				sShowNames += '</ul>';
				sHtml += sShowNames;
			}

		}
	}

	if( k == null ) sHtml += '<li class="empty"><label>Нет событий.</label></li>';

	sHtml += "</ul>";


	return sHtml;

}


qCalendar.fnSetSize = function()
{
	var iTop = this.$el.offset().top;
	var iWindowHeight = $(window).height();
	var iHeaderHeight = this.$header.outerHeight();

	this.fnCloseCell();


	var iTableHeight = (iWindowHeight - iTop - iHeaderHeight - (this.sView=="year"?72:48)); // 48px — требуемый «воздух».
	// ↑ Важно! Отмечу, что реально высота может получиться больше, т.к. минимальная высота ячейки - 64px (см. ниже)
	this.$calendarsUl.css({"max-height": Math.max(128, iTableHeight)}); // воздух здесь не нужен, т.к. кнопка «Календари» расположена выше, чем первая строка с недлей (а мы меряем по ней)
	// ↑ … но для списка нам как раз-таки iTableHeight подходит, т.к. он всегда должен помещаться на экране (если только, конечно, экран не совсем уж маленький)

	                                                // ↓ #FIXME
	if(this.sView=="month") var iCellHeight = Math.max(64, Math.floor(iTableHeight/this.$table.find("tr.week").length)) ;
	if(this.sView=="year") var iCellHeight = Math.max(128, Math.floor(iTableHeight/this.$table.find("tr.halfyear").length)) ;

	var $table_new = this.$table.clone(true, true);

	QCalendarWidget.getData('weekHeight').handler(this.sView,$table_new,iCellHeight);
	//if(this.sView=="month") $table_new.find("tr td.week-number").css({"height":iCellHeight+"px", "max-height":iCellHeight+"px"});
	//if(this.sView=="year") $table_new.find("tr td.cal-cell:first-child").css({"height":iCellHeight+"px", "max-height":iCellHeight+"px"});


	$table_new.find("td.cal-cell").each(function(key, value)
	{
		var $this = $(this);
		var iDateNumHeight = 18; // #FIXME

		var $ul = $this.children(".content").children("ul.calendars-counts");
		var a$li = $ul.children("li");
		var iCount = a$li.not(".more").length;
		var iLiHeight = 14; // #FIXME

		a$li.filter(".more").remove();
		a$li.filter(".hidden").removeClass("hidden");

		var iThisFullCellHeight = iDateNumHeight + iLiHeight*iCount + 4; // 4 — «воздух», равный margin ul

		if(iThisFullCellHeight > iCellHeight && !QCalendarWidget.on)
		{
			var iAllowed = Math.floor( (iCellHeight - iDateNumHeight - 4) / iLiHeight) - 1; // 1 - элемент в котором будет написано «+ ещё 1».
			                                                                                // 4 — «воздух», равный margin ul
			a$li.filter(":gt("+(iAllowed-1)+")").addClass("hidden");
			var iHidden = iCount - iAllowed;
			a$li.eq(iAllowed-1).after('<li class="more"><a>+ ещё '+iHidden+'</a></li>');
		}

	});

	this.$table.replaceWith($table_new);
	this.$table = $table_new;
	$table_new = null;

	QCalendarWidget.getData('cellsStyle').handler($('.calendar-table'));
	QCalendarWidget.getData('todayActivate').handler(QCalendarWidget.bActive++);
}

qCalendar.fnGnerateQuery = function(oOptions)
{
	var aDataToSend = {};
	aDataToSend.month = this.iMonth+1;
	aDataToSend.year = this.iYear;
	aDataToSend.week = this.iWeek+1;
	aDataToSend.view = this.sView;
	aDataToSend.calendars =  this.oOptions.aCalendarsSelected;

	return aDataToSend;
}

qCalendar.fnRefresh = function()
{
	this.fnGetData();
}

qCalendar.fnGetData = function(oOptions)
{
	var oOptions = $.extend({bShowLoadingMsg:true}, oOptions);

	if(typeof(oOptions.sView) !== 'undefined') this.sView = oOptions.sView;
	else oOptions.sView = this.sView;

	// Сформируем массив данных, которые надо туда отправить
	var aDataToSend = this.fnGnerateQuery(oOptions);

	if(this.xhr !== null) this.xhr.abort(); //
	this.xhr = $.ajax((Q.WORKSPACE?'/'+Q.WORKSPACE:'')+QCalendarWidget.url_prefix+"/calendar2/ajax",
	{
		type: "POST",
		data: aDataToSend,
		dataType: "json",
		beforeSend: $.proxy(function()
		{
			this.$el.trigger("started.loading");
			if(oOptions.bShowLoadingMsg)
			{
				///// this.$tbody.html('<tr><td class="msg">'+this.oLang.loading+'</td></tr>');

			}

		}, this),
		complete: $.proxy(function()
		{
			this.$el.trigger("completed.loading");

		}, this),
		error: $.proxy(function(xhr, textStatus)
		{
			switch(textStatus)
			{
				case 'abort':
					break;
				case 'timeout':
					this.$el.trigger("errored.loading");
					this.$table.html('<tr><td class="msg error">'+this.oLang.errorTimeout+'</td></tr>');
					break;
				case "error":
				case null:
				default:
					this.$el.trigger("errored.loading");
					this.$table.html('<tr><td class="msg error">'+this.oLang.error+'</td></tr>');
			}

		}, this),
		success: $.proxy(function(oData) // proxy for 'this'
		{
			this.$el.trigger("succeed.loading");

			this.oData = oData;
			this.fnDraw();

		}, this)

	});


}
